import { render, staticRenderFns } from "./FileDrawer.vue?vue&type=template&id=56b41557&"
import script from "./FileDrawer.vue?vue&type=script&lang=js&"
export * from "./FileDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FileDrawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports